module.exports = __webpack_public_path__ + "static/media/1c_background.da94f3c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/1c_background.png
// module id = 2506
// module chunks = 0